<app-search-bar></app-search-bar> <router-outlet></router-outlet>
